import { Controller } from '@hotwired/stimulus'
import CommaSeparatedValue from '../../../../../../packs/src/admin/comma_separated_value'
import $ from 'jquery'

export default class extends Controller {
  static targets = ['tab', 'pane']

  connect () {
    this.showTab(0)
    this.controlReportTab()
    this.controlRefundTab()
  }

  changeTab (event) {
    event.preventDefault()
    const index = this.tabTargets.indexOf(event.currentTarget)
    this.showTab(index)
  }

  showTab (index) {
    this.tabTargets.forEach((tab, i) => {
      tab.classList.toggle('viewcomponent::admin::ca::request::contracts::form::active', i === index)
    })
    this.paneTargets.forEach((pane, i) => {
      pane.classList.toggle('viewcomponent::admin::ca::request::contracts::form::active', i === index)
      pane.classList.toggle('d-none', i !== index)
    })
  }

  controlReportTab () {
    // 計上・請求月が空なら年を自動入力
    const accountingYear = document.getElementById('ca_request_contract_form_accounting_date_1i')
    const publishedYear = document.getElementById('ca_request_contract_form_published_at_1i')
    const appropriationYear = document.getElementById('ca_request_contract_form_appropriation_date_1i')
    const billingYear = document.getElementById('ca_request_contract_form_billing_date_1i')

    if (!accountingYear || !publishedYear || !appropriationYear || !billingYear) { return }

    [accountingYear, publishedYear, appropriationYear, billingYear].forEach(element => {
      if (element.value === '') {
        element.value = new Date().getFullYear()
      }
    })
    //

    // 成約金額をカンマ付きで表示
    const contractPrice = document.getElementById('ca_request_contract_form_contract_price')
    if (!contractPrice) { return }
    new CommaSeparatedValue(contractPrice).initialize()
    //
  }

  controlRefundTab () {
    // refund
    // 税計算
    const priceField = document.getElementById('ca_request_contract_form_refund_price')
    if (!priceField) { return }

    // 初期描画時
    if (priceField.value !== '') {
      calcTax()
    }

    const commaSeparatedValue = new CommaSeparatedValue(priceField) // 金額をカンマ付きで表示するクラス
    commaSeparatedValue.initialize()

    $(priceField).on('change', () => {
      calcTax()
    })

    function calcTax () {
      const price = priceField.value
      const taxRate = document.getElementById('ca_request_contract_form_tax_rate').value
      const taxAmountField = document.getElementById('ca_request_contract_form_tax_amount')
      const taxIncludedPriceField = document.getElementById('ca_request_contract_form_tax_included_price')
      const taxAmount = (!price ? '' : (Math.trunc(Number(price) * parseFloat(taxRate))))
      const taxIncludedPrice = (!price ? '' : (Number(price) + taxAmount))
      taxAmountField.value = taxAmount.toLocaleString()
      taxIncludedPriceField.value = taxIncludedPrice.toLocaleString()
    }

    // 返還金計算
    const calcMethodSelect = document.getElementById('ca_request_contract_form_calculation_method')
    const priceFieldOverlap = document.getElementById('ca_request_contract_form_refund_price_overlap')

    $(calcMethodSelect).on('change', (e) => {
      switch (e.target.value) {
        case 'speee':
          priceField.value = calcRefundPrice()
          priceField.readOnly = true
          commaSeparatedValue.syncValue()
          break
        case 'other_company':
          priceField.value = ''
          priceField.readOnly = false
          priceFieldOverlap.readOnly = false
          commaSeparatedValue.syncValue()
          break
        default:
          priceField.value = ''
          priceField.readOnly = true
          commaSeparatedValue.syncValue()
          break
      }
      calcTax()
    })

    $('#ca_request_contract_form_move_in_at, #ca_request_contract_form_passed_at, #ca_request_contract_form_contract_price').on('change', () => {
      if (!(calcMethodSelect.value === 'speee')) return
      priceField.value = calcRefundPrice()
      calcTax()
    })

    function calcRefundPrice () {
      const moveInAt = new Date(document.getElementById('ca_request_contract_form_move_in_at').value)
      const passedAt = new Date(document.getElementById('ca_request_contract_form_passed_at').value)
      const contractPrice = document.getElementById('ca_request_contract_form_contract_price').value
      const residenceDays = Math.floor((passedAt - moveInAt) / (1000 * 60 * 60 * 24)) + 1// 日付の引き算の返り値はミリ秒のため、1日をミリ秒にした値で割って日数を求めている
      if (residenceDays >= 90) return 0
      return Math.floor((90 - residenceDays) * (contractPrice / 90)) * (-1)
    }

    const toggleDisabledByTargetElement = (targetElement) => {
      const refundElements = document.getElementById('tab-refund')
      const appropriationDateForms = [1, 2, 3].map(n => document.getElementById(`ca_request_contract_form_appropriation_date_${n}i`))
      // 返還金計上月がFormLockHelperによってdisabledにされていないときだけ制御の対象とする
      if (appropriationDateForms[0].dataset.locked === 'false') {
        appropriationDateForms.forEach(dateForm => {
          dateForm.classList.add('disabled-target')
        })
      }
      // discard_dayによってhiddenとなったinputにはdate_selectのclassが適用されないためJSでclassを適用する
      document.getElementById('ca_request_contract_form_billing_date_3i').className = 'disabled-target'
      const refundForms = refundElements.querySelectorAll('.disabled-target')
      const alertText = document.createElement('p')
      alertText.textContent = '成約データの請求月が未入力の場合、返還金の編集はできません。'
      alertText.className = 'refund-alert-text'
      const displayedAlertText = document.querySelector('.refund-alert-text')

      if (targetElement.value !== '') {
        displayedAlertText && displayedAlertText.remove()
        removeDisabled(refundForms)
      } else {
        displayedAlertText || refundElements.prepend(alertText)
        toDisabled(refundForms)
      }
    }

    const toDisabled = (elements) => {
      elements.forEach(element => {
        if (element.disabled !== true) {
          element.disabled = true
        }
      })
    }

    const removeDisabled = (elements) => {
      elements.forEach(element => {
        if (element.disabled === true) {
          element.removeAttribute('disabled')
        }
      })
    }

    const accountingDateMonthField = document.getElementById('ca_request_contract_form_published_at_2i')
    toggleDisabledByTargetElement(accountingDateMonthField)

    $(accountingDateMonthField).on('change', (e) => {
      toggleDisabledByTargetElement(e.target)
    })

    function setValueToNegative () {
      if (priceField.value < 0 || priceField.value === '') return
      priceField.value = -1 * priceField.value
    }

    $(priceField).on('change', () => {
      setValueToNegative()
    })
  }
}
